import http from "api/https";

export const getExecutorsByApprovalRequestId = (approval_request_id: number): Promise<any> => {
  return http.get(`/ApprovalRequestExecutor/GetByApprovalRequestId?approval_request_id=${approval_request_id}`);
};

export const getAllOrgUsers = (): Promise<any> => {
  return http.get(`/ApprovalRequestExecutor/GetAllOrgUsers`);
};

export const createExecutor = (data: { approval_request_id: number; user_account_id: number }): Promise<any> => {
  return http.post('/ApprovalRequestExecutor', data);
};

export const deleteExecutor = (id: number): Promise<any> => {
  return http.post('/ApprovalRequestExecutor/Delete', { id });
};
